import {Component, input, model} from '@angular/core';
import {RouterLink} from "@angular/router";
import {BsMenuItemComponent} from "../bs-menu-item/bs-menu-item.component";

@Component({
  selector: 'bs-menu',
  imports: [
    RouterLink,
    BsMenuItemComponent
  ],
  templateUrl: './bs-menu.component.html',
  styleUrl: './bs-menu.component.css',
  standalone: true
})
export class BsMenuComponent {
  items = input<any>();
  selectedItem = model<any>();

}
